var _circle, _circle2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleFsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 403,
    viewBox: "0 0 800 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599.756,
    cy: 203,
    r: 200,
    transform: "rotate(90 599.756 203)",
    fill: "url(#paint0_linear_3956_2083)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    transform: "rotate(90 200 200)",
    fill: "url(#paint1_linear_3956_2083)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 200,
    rx: 112,
    ry: 112,
    transform: "rotate(90 200 200)",
    fill: "url(#paint2_linear_3956_2083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3956_2083",
    x1: 601.62,
    y1: 38.1956,
    x2: 620.262,
    y2: 427.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80ABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3956_2083",
    x1: 201.864,
    y1: 35.1956,
    x2: 220.506,
    y2: 424.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503125,
    stopColor: "#0057FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3956_2083",
    x1: 201.043,
    y1: 107.71,
    x2: 211.483,
    y2: 325.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFsvg);
export default __webpack_public_path__ + "static/media/circleF.svg.5777b06fdbc4bb7c0e8ba65dddc4a170.svg";
export { ForwardRef as ReactComponent };